import React from 'react';

interface ChevronProps {
  direction: 'up' | 'down';
}

export const ChevronIcon: React.FC<ChevronProps> = ({ direction }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      className={`transition-transform duration-300 ${
        direction === 'up' ? 'rotate-180' : ''
      }`}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.96967 6.21967C4.26256 5.92678 4.73744 5.92678 5.03033 6.21967L9 10.1893L12.9697 6.21967C13.2626 5.92678 13.7374 5.92678 14.0303 6.21967C14.3232 6.51256 14.3232 6.98744 14.0303 7.28033L9.53033 11.7803C9.23744 12.0732 8.76256 12.0732 8.46967 11.7803L3.96967 7.28033C3.67678 6.98744 3.67678 6.51256 3.96967 6.21967Z"
        fill="#1D1D1E"
      />
    </svg>
  );
};
